import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createFakeGetResponder, createFakePutResponder } from '../../../test-utils';
import { createContentVisibilityApi, contentScopeSettingsApiRelativePath, localesSettingsApiRelativePath } from './index';
export var createContentVisibilityApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createContentVisibilityApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetLocaleContentSettings: function (dto) {
            return createFakeGetResponder(fakeHttp, contentScopeSettingsApiRelativePath + "/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        whenUpdateLocaleContentSettings: function (dto) {
            return createFakePutResponder(fakeHttp, contentScopeSettingsApiRelativePath + "/" + dto.locale)(dto.brandid ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        },
        whenGetEnabledLocales: function (brandId) {
            return createFakeGetResponder(fakeHttp, localesSettingsApiRelativePath + "/enabled" + (brandId ? "?brandId=" + brandId : ''));
        },
        whenEnableLocale: function (dto) {
            return createFakePutResponder(fakeHttp, localesSettingsApiRelativePath + "/" + dto.locale + "/enable" + (dto.brandId ? "?brandId=" + dto.brandId : ''))({});
        },
        whenDisableLocale: function (dto) {
            return createFakePutResponder(fakeHttp, localesSettingsApiRelativePath + "/" + dto.locale + "/disable" + (dto.brandId ? "?brandId=" + dto.brandId : ''))({});
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map